import {ViewChild, AfterViewInit, Component, Input, OnInit, OnChanges, SimpleChanges, OnDestroy} from '@angular/core';
import {Chart, ChartOptions, TooltipItem, registerables} from 'chart.js';

Chart.register(...registerables);

@Component({
    selector: 'app-line-chart',
    templateUrl: './line-chart.component.html',
    styleUrls: ['./line-chart.component.css'],
    standalone: false
})
export class LineChartComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @ViewChild('canvases', { static: true }) myCanvas;
  context: CanvasRenderingContext2D;
  @Input() data: any;
  lineChart: Chart;
  options: ChartOptions<'line'> = {};

  ngOnInit() {
    this.options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: true
        },
        tooltip: {
          enabled: true,
          mode: 'nearest',
          intersect: true,
          callbacks: {
            label: (item: TooltipItem<'line'>) => {
              const value = Number(item.parsed.y);
              const formatted = value.toLocaleString('en-us', {minimumFractionDigits: 2});
              return item.dataset.label === 'Transactions' ? formatted : '$' + formatted;
            }
          }
        }
      },
      elements: {
        line: {
          tension: 0 // disables bezier curves
        }
      },
      scales: {
        x: {
          display: true,
          grid: {
            display: false
          }
        },
        y: {
          display: true,
          grid: {
            display: false
          },
          ticks: {
            callback: (value) => '$ ' + Number(value).toLocaleString('en-us', {minimumFractionDigits: 2}) + ' USD'
          }
        }
      }
    };
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data && !changes.data.firstChange) {
      this.render();
    }
  }

  ngAfterViewInit(): void {
    this.render();
  }

  ngOnDestroy(): void {
    if (this.lineChart) {
      this.lineChart.destroy();
      this.lineChart = null;
    }
  }

  private render(): void {
    if (!this.myCanvas || !this.myCanvas.nativeElement) {
      return;
    }
    this.context = (this.myCanvas.nativeElement as HTMLCanvasElement).getContext('2d');
    if (this.lineChart) {
      this.lineChart.destroy();
    }
    this.lineChart = new Chart(this.context, {
      type: 'line',
      data: this.data || {labels: [], datasets: []},
      options: this.options
    });
  }
}
